import React from 'react';
import InstitutionManagementView from './InstitutionManagementView';

const InstitutionManagementContainer = (props) => {
  return <InstitutionManagementView {...props} />;
};

export default InstitutionManagementContainer;
